import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import { Modal, ModalBody, ModalFooter, Button, Input, Form, Select, ToggleSwitch, PasswordIndicator, Tabs, TabContainer, Accordion, Tooltip } from "@gpstrackit/react-controls";
import { Checkbox } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Grid, Icon, Divider, Chip, Alert } from "@mui/material";
import CustomSelect from 'Components/Select';

//Actions 
import {
    dealersGetDealerRequest,
    dealersCreateDealerRequest,
    dealersEditDealerRequest,
    dealersSearchTimeZonesRequest,
    searchEntityRequest,
    clearRedux,
} from 'Redux/actions';
import { getSfAccount, getAccounts } from './redux/saga'

//Helpers
import { passwordValidation, generatePassword } from 'Utils/helpers';

//Styles
import './index.scss';
import { set } from "lodash";

const CreateEditDealer = (props) => {
    const { tableRef, getDealer, brandParam } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);

    const languageOptions = [
        {
            id: 1,
            name: messages['english_label']
        },
        {
            id: 2,
            name: messages['spanish_label']
        },
    ]

    const [name, setName] = useState("");
    const [nameTitle, setNameTitle] = useState("");
    const [timezone, setTimeZone] = useState(null);
    const [language, setLanguage] = useState(null);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [sfAccount, setSfAccount] = useState(null);
    const [masterAccount, setMasterAccount] = useState(null);
    const [automaticPassword, setAutomaticPassword] = useState(false);
    const [brand, setBrand] = useState(brandParam || null);

    const {
        timeZones,
        loadingEntity,
        brands,
    } = useSelector(state => state.generalRedux);

    const {
        createDealer,
        editDealer,
        loading,
        openModal,
        dealer,
        resultDealer,
        resultDealerLoading
    } = useSelector(state => state.createEditDealerRedux);

    const { user } = useSelector(state => state.securityRedux);

    const closeModal = () => {
        dispatch(clearRedux("CREATE_EDIT_DEALER"));
        setName("");
        setLanguage(null);
        setTimeZone(null)
        setUsername("")
        setEmail("")
        setPassword("");
        setNameTitle("");
        setAutomaticPassword(false);
        setMasterAccount(null);
        setBrand(null);

    }

    const validateUsername = (value) => {
        let regex = /^[a-z0-9]{3,20}$/;
        return (value.match(regex) != null)
    }

    const saveDealer = () => {

        let payload = {
            name: name?.trim(),
            username: username?.trim(),
            email: email?.trim(),
            password: password?.trim(),
            masterCompanyId: masterAccount?.id || null,
            timezoneId: timezone?.id,
            language: language?.id,
            brandId: brand?.id,

        }

        dispatch(dealersCreateDealerRequest(payload));
    }

    const editDealerRequest = () => {
        let payload = {
            id: dealer?.id,
            name: name?.trim(),
            brandId: brand?.id,
        }

        dispatch(dealersEditDealerRequest(payload))
    }

    const copyToClipboard = () => {
        let aux = document.createElement('input');
        aux.setAttribute('value', password);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand('copy');
        document.body.removeChild(aux);

        NotificationManager.success(
            messages['create_dealer_the_password_was_copied'],
            messages['create_dealer_create_title'],
            3000
        );
    }

    const getSfAccountForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getSfAccount(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                const accounts = items?.length ? items.filter(item => item?.id !== masterAccount?.id) : []
                callback(accounts)
            }
        })
    }
    const mapProvider = ["google", "osm", "osmOnly"]

    useEffect(() => {
        if (openModal) {
            timeZones && timeZones.length === 0 && dispatch(dealersSearchTimeZonesRequest());

        }
    }, [openModal]);

    useEffect(() => {
        if (dealer) {
            dispatch(dealersGetDealerRequest(dealer.id))
        }
    }, [dealer])

    useEffect(() => {

        // Response when creating an dealer
        if (createDealer?.id) {
            NotificationManager.success(
                messages['create_dealer_the_dealer_was_created'],
                messages['create_dealer_create_title'],
                3000,
            );
            tableRef && tableRef?.current?.getData();
            getDealer && getDealer();
            closeModal();
        }

        //Get current dealer information
        if (resultDealer?.id) {
            let currentLanguage = languageOptions?.length ? languageOptions?.find(item => item.id === resultDealer?.masterCompany?.language) : null
            let currentTimeZone = timeZones?.length ? timeZones?.find(item => item.id === resultDealer?.masterCompany?.timezoneId) : null
            let currentBrand = brands?.length ? brands?.find(item => item.id === resultDealer?.brandId) : null

            setName(resultDealer?.name || "");

            let name = resultDealer?.name
            if (name.length >= 7) {
                name = name.substring(0, 25) + "...";
            }

            setNameTitle(name || "");
            setUsername(resultDealer?.username || "");
            setEmail(resultDealer?.email || "");
            setPassword(resultDealer?.password || "");
            setMasterAccount(resultDealer?.masterCompany || null);
            setLanguage(currentLanguage || null);
            setTimeZone(currentTimeZone || null);
            setBrand(currentBrand || null);
            dispatch(clearRedux("CREATE_EDIT_DEALER", { resultDealer: null }));
        }
        //Dealer editing confirmation message
        if (editDealer?.id) {
            NotificationManager.success(
                messages['create_dealer_the_dealer_has_been_edited'],
                messages['create_dealer_edit_title'],
                3000,
            );
            tableRef && tableRef?.current?.getData();
            getDealer && getDealer();
            closeModal();
        }

    }, [createDealer, resultDealer, editDealer, brands, timeZones]);

    useEffect(() => {
        if(openModal){
            dispatch(searchEntityRequest({ key: "timezones" }));
            dispatch(searchEntityRequest({ key: "brands" }));
        }
       
    }, [openModal]);

    return (
        <Modal
            open={openModal}
            title={dealer ? `${messages['create_dealer_edit_title']} - ${nameTitle}` : messages['create_dealer_create_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading || resultDealerLoading}
            size="small"
            className="create-dealer-modal"
        >
            <ModalBody className="body-create-dealer">

                <div className="create-dealer-tab-container">
                    <Form
                        ref={formRef}
                        onSubmit={() => {
                            return true
                        }}
                        onValidSubmit={() => {

                            if (!dealer) {
                                if (username) {
                                    let userNameRules = validateUsername(username)
                                    if (!userNameRules) {
                                        NotificationManager.warning(
                                            messages['create_dealer_error_username'],
                                            messages['create_dealer_create_title'],
                                            3000,
                                        );
                                        return
                                    }
                                }

                                let checkPassword = passwordValidation(password);
                                if (!checkPassword) {
                                    NotificationManager.error(
                                        messages['error_password'],
                                        messages['create_dealer_create_title'],
                                        3000
                                    );
                                    return;
                                }
                            }

                            if (!dealer) {
                                saveDealer();
                            } else {
                                editDealerRequest();
                            }
                        }}
                    >
                        <div style={{ margin: 10 }}>
                            <Input
                                type="text"
                                label={messages['create_dealer_dealer_name']}
                                placeholder={messages['create_dealer_dealer_name']}
                                value={name}
                                onChange={(value) => setName(value)}
                                required
                                requiredMessage={messages['required_field']}
                                maxLength={40}
                                minLength={3}
                                minLengthMessage={`${messages['create_dealer_dealer_name_min_error']} 3`}
                                maxLengthMessage={`${messages['create_dealer_dealer_name_max_error']} 40`}
                            />
                        </div>
                        {
                            <div className="edit-dealer-disabled-input" style={{ margin: 10 }}>
                                <Input
                                    type="text"
                                    label={messages['create_dealer_username']}
                                    placeholder={messages['create_dealer_username']}
                                    autoComplete="new-password"
                                    value={username}
                                    onChange={(value) => setUsername(value)}
                                    required
                                    requiredMessage={messages['required_field']}
                                    maxLength={20}
                                    minLength={3}
                                    minLengthMessage={`${messages['create_dealer_username_error_min']} 3`}
                                    maxLengthMessage={`${messages['create_dealer_username_error_max']} 20`}
                                    onBlur={() => {
                                        let currentUsername = username || ''
                                        if (username) {
                                            currentUsername = currentUsername.replace(/[^\w]/gi, '');
                                            currentUsername = currentUsername.toLowerCase();
                                            setUsername(currentUsername);
                                        }
                                    }}
                                    disabled={dealer}
                                />
                            </div>
                        }
                        {
                            <div className="edit-dealer-disabled-input" style={{ margin: 10 }}>
                                <Input
                                    type="email"
                                    label={messages['create_dealer_email']}
                                    placeholder={messages['create_dealer_email']}
                                    autoComplete="new-password"
                                    value={email}
                                    onChange={(value) => setEmail(value)}
                                    required
                                    requiredMessage={messages['required_field']}
                                    email
                                    emailMessage={messages['pmusers_user_email_is_invalid']}
                                    disabled={dealer}
                                />
                            </div>
                        }
                        {
                            !dealer &&
                            <div style={{ margin: 10 }}>
                                <div className="automatic-password-container">
                                    <label className="input-normal-label">{messages['create_dealer_password']} <span className="text-danger"> *</span></label>
                                    <ToggleSwitch
                                        id="automatic-password"
                                        large
                                        blueToggle
                                        optionLabels={[messages['create_dealer_automatic'], messages['create_dealer_manual']]}
                                        checked={automaticPassword}
                                        onChange={(checked) => {
                                            let autPassword = generatePassword(20);
                                            if (checked) setPassword(autPassword);
                                            else setPassword("");
                                            setAutomaticPassword(checked);
                                        }}
                                        disabled={dealer}
                                    />
                                </div>
                                <Input
                                    type="password"
                                    placeholder={messages['create_dealer_password']}
                                    value={password}
                                    onChange={(value) => setPassword(value)}
                                    autoComplete="new-password"
                                    required
                                    requiredMessage={messages['required_field']}
                                    maxLength={20}
                                    minLength={6}
                                    minLengthMessage={`${messages['pmusers_min_chars_password']} 6`}
                                    maxLengthMessage={`${messages['pmusers_max_chars_password']} 20`}
                                    disabled={dealer}
                                />
                                <div style={{ marginTop: 3 }}>
                                    {password && <PasswordIndicator password={password} messages={messages} />}
                                </div>
                                {password &&
                                    <span
                                        className="copy-label"
                                        onClick={() => copyToClipboard()}
                                    >
                                        {messages['create_dealer_click_to_copy_password']}
                                    </span>
                                }
                            </div>
                        }
                        {
                            <div style={{ margin: 10 }}>
                                <CustomSelect
                                    async
                                    value={masterAccount}
                                    onChange={(master) => {
                                        setMasterAccount(master);

                                        if (master) {
                                            let currentLanguage = languageOptions.find(item => item.id === master?.language)
                                            let currentTimeZone = timeZones.find(item => item.id === master?.timezoneId)
                                            setLanguage(currentLanguage);
                                            setTimeZone(currentTimeZone);
                                        } else {
                                            setLanguage(null);
                                            setTimeZone(null);
                                        }
                                    }}
                                    label={messages['create_dealer_master_company']}
                                    placeholder={messages["create_dealer_master_company"]}
                                    loadOptions={getAccountsForSelect}
                                    getOptionLabel={e => `${e.name} - ${e.id}`}
                                    getOptionValue={e => e.id}
                                    disabled={dealer}
                                />
                            </div>
                        }
                        {
                            <div style={{ margin: 10 }}>
                                <Select
                                    id="language"
                                    value={language}
                                    options={languageOptions}
                                    label={messages['create_dealer_language']}
                                    onChange={(value) => setLanguage(value)}
                                    valueField="id"
                                    textField="name"
                                    placeholder={messages['create_dealer_select']}
                                    disabled={dealer || masterAccount}
                                    required={masterAccount ? false : true}
                                    requiredMessage={messages['required_field']}
                                />
                            </div>
                        }
                        {
                            <div style={{ margin: 10 }}>
                                <Select
                                    id="time-zone"
                                    value={timezone}
                                    options={timeZones}
                                    label={messages['create_dealer_time_zone']}
                                    onChange={(value) => setTimeZone(value)}
                                    loading={loadingEntity}
                                    valueField="id"
                                    textField="name"
                                    placeholder={messages['create_dealer_select']}
                                    disabled={dealer || masterAccount}
                                    required={masterAccount ? false : true}
                                    requiredMessage={messages['required_field']}
                                />
                            </div>
                        }
                        {
                            <div style={{ margin: 10 }}>
                                <Select
                                    id="brand"
                                    value={brand}
                                    options={brands}
                                    label={messages['create_dealer_brand']}
                                    onChange={(value) => setBrand(value)}
                                    loading={loadingEntity}
                                    valueField="id"
                                    textField="title"
                                    placeholder={messages['create_dealer_brand']}
                                    required={true}
                                    requiredMessage={messages['required_field']}
                                    menuPlacement="top"
                                    disabled={brandParam}
                                />
                            </div>
                        }
                    </Form>
                </div>

            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => {
                        closeModal();
                    }}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => {

                        formRef?.current?.submit();

                    }}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal >
    );
}
export default CreateEditDealer